import React from 'react';
import { string, func } from 'prop-types';
import { MenuItemContainer, MenuItemContent } from './BurgerMenu.style';

const MenuItem = ({ children, to, onClick }) => {
  return (
    <MenuItemContainer>
      <MenuItemContent
        to={to}
        onClick={onClick}
      >
        {children}
      </MenuItemContent>
    </MenuItemContainer>
  );
};

MenuItem.propTypes = {
  children: string.isRequired,
  to: string.isRequired,
  onClick: func.isRequired
};

export default MenuItem;
